"use client";

import React, { useEffect, useState } from "react";
import { Quote, ShieldCheck } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Sarah Jenkins",
  quote: "GOTMEDS.IO has completely changed how I manage my chronic medication. The coordination with my doctor in Buckhead is seamless and incredibly fast.",
  position: "Buckhead, GA"
}, {
  author: "Dr. Marcus Thorne",
  quote: "As a physician, I trust GOTMEDS.IO to handle my patients' prescriptions with the highest level of clinical precision and local reliability.",
  position: "Midtown Medical Center"
}];
export default function VoicesOfSecurity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="223164" id="patient-voices" className="dark bg-background py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-10">
        <div className="w-[800px] h-[800px] rounded-lg bg-gradient-to-br from-primary/30 via-secondary/20 to-transparent blur-3xl mix-blend-screen" />
      </div>

      <div ref={ref} className={cn("container mx-auto px-4 md:px-6 relative z-10 max-w-4xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight text-foreground mb-4">
            Patient Voices
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Hear from the Atlanta community members who rely on our doctor-integrated delivery network for their health.
          </p>
        </div>

        <div className="relative bg-card/50 backdrop-blur-md shadow-2xl shadow-black/20 border border-border/40 rounded-2xl p-8 md:p-16">
          <Carousel setApi={setApi} opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                  <div className="flex flex-col items-center text-center space-y-8">
                    <div className="relative">
                      <div className="size-20 rounded-lg border-2 border-secondary p-1">
                        <img src={`/img/patient_avatar_${index + 1}.png`} alt={testimonial.author} className="w-full h-full rounded-lg object-cover" />
                      </div>
                      <Quote className="absolute -bottom-2 -right-2 size-8 text-secondary fill-secondary/20" />
                    </div>
                    
                    <blockquote className="text-xl md:text-3xl font-serif italic text-foreground leading-relaxed max-w-3xl tracking-tight">
                      "{testimonial.quote}"
                    </blockquote>
                    
                    <div className="flex flex-col items-center space-y-3 pt-4">
                      <div className="space-y-1">
                        <div className="font-default font-bold text-xl text-foreground">
                          {testimonial.author}
                        </div>
                        <div className="text-sm font-mono uppercase tracking-widest text-secondary">
                          {testimonial.position}
                        </div>
                      </div>
                      
                      <Badge variant="secondary" className="mt-2 text-primary-foreground bg-primary hover:bg-primary/90 border-transparent transition-all shadow-sm">
                        <ShieldCheck className="size-3.5 mr-1" />
                        Verified Patient
                      </Badge>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex justify-center gap-3 mt-12">
            {Array.from({
            length: count
          }).map((_, i) => <button key={i} data-index={i} className={cn("h-1.5 rounded-full transition-all duration-500 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary", current === i + 1 ? "w-10 bg-secondary" : "w-3 bg-muted hover:bg-muted-foreground/40")} onClick={() => api?.scrollTo(i)} aria-label={`Go to slide ${i + 1}`} />)}
          </div>
        </div>
      </div>
    </section>;
}